<!--
 * @Author: wangpeng
 * @Date: 2025-03-17 16:42:10
 * @LastEditors: wangpeng
 * @LastEditTime: 2025-03-21 15:53:37
 * @FilePath: \web_h5\src\views\FriendshipLevel\intimateRule.vue
 * @Description: Unknown
-->
<template>
  <div class="intimate-rule">
    <van-nav-bar class="van-bar" title="" :style="`paddingTop:${barHeight}px`" left-arrow @click-left="handleBack">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" />
        <span class="tit-left">
          {{ $t('lang.intimate.pageTitNew') }}
        </span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="prologue">{{ $t('lang.friendshipLevel.prologue') }}</div>
      <div class="titie1">{{ $t('lang.friendshipLevel.ruleTitle1') }}</div>
      <div class="text1">{{ $t('lang.friendshipLevel.ruleText1') }}</div>
      <div class="titie2">{{ $t('lang.friendshipLevel.ruleSubtitle1') }}</div>
      <div class="text1">{{ $t('lang.friendshipLevel.ruleText2') }}</div>
      <div class="titie2">{{ $t('lang.friendshipLevel.ruleSubtitle2') }}</div>
      <div class="text1">{{ $t('lang.friendshipLevel.ruleText3') }}</div>
      <div class="titie1">{{ $t('lang.friendshipLevel.ruleTitle2') }}</div>
      <div class="text1">{{ $t('lang.friendshipLevel.ruleText4') }}</div>
      <div class="titie1">{{ $t('lang.friendshipLevel.ruleText5') }}</div>
      <div class="text1">{{ $t('lang.friendshipLevel.epilogue') }}</div>
    </div>
  </div>
</template>

<script>
// 亲密度规则
export default {
  created() {
    this.$client.addEvent('ep_about_bond_page')
  },
  methods: {
    handleBack() {
      const query = this.$route.query
      if (query.fromPage && query.fromPage === 'friendship-level') {
        this.$router.replace({
          path: '/friendship-level',
          query: {
            targetUid: query.targetUid
          }
        })
        return
      }

      this.closeWeb()
    }
  }
}
</script>

<style lang="less" scoped>
.intimate-rule {
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
  .main {
    height: 100%;
    padding: 16px 20px;
    color: #666666;
    line-height: 24px;
    font-size: 15px;
    .titie1 {
      font-size: 17px;
      color: #333;
      font-weight: bold;
    }
    .titie2 {
      font-size: 17px;
      color: #333;
      font-weight: bold;
    }
    .text1 {
      padding-left: 14px;
    }
  }
}
</style>
